module.exports = "/static/js/5a893da67c8de73586e07e67347e4a0c.png";